import { Component, EventEmitter, Input, Output } from '@angular/core';

export class NavControl {
    constructor(public label: string, public icon: string) { }
}


import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-request-controls',
    templateUrl: './request-controls.component.html',
    styles: [],
    standalone: true,
    imports: [TranslateModule]
})
export class RequestControlsComponent {
    @Input() controls!: { prev?: NavControl | null, next?: NavControl };
    @Input() pending = false;
    @Input() disabled = false;
    @Output() direction: EventEmitter<string> = new EventEmitter<string>();

    prev(): void {
        this.direction.emit('prev');
    }

    next(): void {
        this.direction.emit('next');
    }
}
